import React from "react";
import browserStorage from "store";

const defaultState = browserStorage.get("user") ?? {
  EmployeeId: "",
  DisplayName: "",
  Designation: "",
  CashCenterId: "",
  Permissions: "",
  customer: null,
  workStation: null,
  UserName: "",
  Assignment: "",
  OfficeId: "",
  filters: {},
};

export const userReducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case "SET_CUSTOMER":
      browserStorage.set("user", { ...state, customer: payload });
      return { ...state, customer: payload };
    case "SET_WORKSTATION":
      browserStorage.set("user", { ...state, workStation: payload });
      return { ...state, workStation: payload };
    case "SET_CURRENT_USER":
      browserStorage.set("user", { ...state, ...payload });
      return { ...state, ...payload };
    case "SAVE_FILTERS":
      return { ...state, filters: payload };
    default:
      return state;
  }
};

export default defaultState;
export const UserContext = React.createContext();
